import { useCallback, useState } from 'react';
import {
  useReadingProgressTracker,
  type ScrollProgressUIState
} from './useReadingProgressTracker';

interface UseScrollProgressUIParams {
  scrollContainerRef: React.RefObject<HTMLDivElement>;
  sceneId: string | undefined;
  updateReadingProgress: (params: {
    sceneId: string;
    body: { episode_id: string; paragraph_index: number; char_offset: number };
  }) => void;
  episodes: { sceneEpisodeId?: string }[];
}

export const useScrollProgressUI = ({
  scrollContainerRef,
  sceneId,
  updateReadingProgress,
  episodes
}: UseScrollProgressUIParams) => {
  const [state, setState] = useState<ScrollProgressUIState>({
    progressPercent: 0,
    currentEpisodeNumber: 1,
    canScrollLeft: false,
    canScrollRight: false
  });

  const onProgressChange = useCallback((newState: ScrollProgressUIState) => {
    setState(newState);
  }, []);

  useReadingProgressTracker({
    scrollContainerRef,
    sceneId,
    updateReadingProgress,
    episodes,
    onProgressChange
  });

  return state;
}
